// Maximum depth allowed for delegation chains
// 0 = root task (not delegated)
// 1 = first level delegation
// 2 = second level delegation (re-delegation)
// ... up to 10 levels of delegation
export const MAX_DELEGATION_DEPTH = 10;
